import { useHistory, useNavigation, useView } from '@/hooks'
import { type LinkEvent, type Target, handleLink } from '@/components/Link/lib/handleLink'
import { type ViewProps, type View } from '../types'

export type LinkHandlerFunction = (
  event: LinkEvent | undefined,
  props: ViewProps,
  target?: Target,
  callbacks?: Record<string, () => void>,
  keepFocus?: boolean,
  readOnly?: { version: bigint }
) => void

export const useLink = (viewName: View) => {
  const history = useHistory()
  const { state, dispatch } = useNavigation()
  const { viewId: origin } = useView()

  return (
    event: LinkEvent | undefined,
    props: ViewProps,
    target?: Target,
    callbacks?: Record<string, () => void>,
    keepFocus?: boolean,
    readOnly?: { version: bigint }
  ): void => {
    handleLink({
      event,
      dispatch,
      viewItem: state.viewRegistry.get(viewName),
      props: { ...props },
      viewId: crypto.randomUUID(),
      origin,
      target,
      onDocumentCreated: callbacks?.onDocumentCreated,
      history,
      keepFocus,
      ...(readOnly && { readOnly })
    })
  }
}
